const suffix = (day: string) =>
	(+day >= 4 && +day <= 20) || (+day >= 24 && +day <= 30) ? 'th' : ['st', 'nd', 'rd'][(+day % 10) - 1];

export default suffix;
